import { render } from "./ServiceInfo.vue?vue&type=template&id=07aaee40&scoped=true&ts=true"
import script from "./ServiceInfo.vue?vue&type=script&lang=ts"
export * from "./ServiceInfo.vue?vue&type=script&lang=ts"

import "./ServiceInfo.vue?vue&type=style&index=0&id=07aaee40&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07aaee40"]])

export default __exports__